<template>
  <v-container>
    <v-row justify="center">
      <v-col cols=12 sm=8>
        <v-card elevation=5 shaped class="mb-5">
          <v-container>
            <v-row>
              <v-col cols=12 class="display-3 font-weight-bold text-center">
                Welcome to Car Gerbil
              </v-col>
              <v-col cols=12 class="headline text-center">
                Your little companion that helps you <span class="font-italic">know</span> your car.
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols=12 class="display-1 font-weight-bold text-center">
        Features
      </v-col>
      <v-col cols=12 sm=8>
        <v-card elevation=8 shaped class="text-center">
          <v-list>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="text-center headline font-weight-bold">
                  Car Inventory
                </div>
                <div class="text-center body-1">
                  A place to store all of your vehicles' information.
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center font-weight-bold headline">
                  MPG Tracking & Analysis
                </div>
                <div class="text-center mt-1 body-1">
                  MPG tracking with GPS features that pin points the exact gas station you fill up at.
                </div>
                <div class="text-center mt-1 body-1">
                  See your most frequented gas station, your average mpg per type of gas per gas station, and more.
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center mt-1 headline font-weight-bold">
                  And More Features in Development
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols=12 class="display-1 font-weight-bold text-center">
        How to Use
      </v-col>
      <v-col cols=12 sm=8>
        <v-card elevation=8 shaped class="text-center">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center font-weight-bold headline">
                  Track your trip mileage
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-cent">
                  Go to your favorite gas station and enable location services on your phone.
                </div>
                <div class="text-center mt-2 body-2">
                  We utilize the Google Maps API to determine what gas station you are at, in order to use that we need the geolocation from your device.
                </div>
                <div class="text-center body-2 font-weight-bold">
                  We only access your location when you create a new MPG entry.
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center mt-2">
                  Log in to your account here on Car Gerbil, go to the New MPG Entry on the Dashboard. Enter your trip mileage. After you fill up, enter the details of the fillup, select the car you are driving, and submit!
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center mt-2">
                  After you are done, click on the Car on the Dashboard and look at your data!
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="text-center mt-2">
                  Keep using Car Gerbil and you will get better data for your car!
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="text-center mt-5">
      <v-col class="title text-center">
        Please login or sign up to continue! <v-icon>far fa-smile</v-icon>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols=6 sm=2 class="text-center">
        <v-btn color="primary" block large to="/login">
          Login
        </v-btn>
      </v-col>
      <v-col cols=6 sm=2 class="text-center">
        <v-btn color="success" block large to="/signup">
          Signup
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      msg: "test",
      ready: false
    }
  }
}
</script>
